import { render, staticRenderFns } from "./ChooseCinema.vue?vue&type=template&id=f4f204d4&scoped=true"
import script from "./ChooseCinema.vue?vue&type=script&lang=js"
export * from "./ChooseCinema.vue?vue&type=script&lang=js"
import style0 from "./ChooseCinema.vue?vue&type=style&index=0&id=f4f204d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f204d4",
  null
  
)

export default component.exports